<template>
  <section>
    <ax-panel title="更改信息">
      <van-cell title="更改类型">
        <span v-if="data.header.qh_phone_flag ==='Y'">电话号码</span>
        <span v-if="data.header.qh_phone_flag ==='Y'&&data.header.qh_photo_flag ==='Y'">、</span>
        <span v-if="data.header.qh_photo_flag ==='Y'">照片</span>
      </van-cell>
      <van-cell title="电话号码" v-if="data.header.qh_phone_flag ==='Y'" v-model="data.header.phone">
        <a class="link_a" :href="'tel:'+data.header.phone">{{data.header.phone}}</a>
      </van-cell>
      <van-cell title="照片" v-if="data.header.qh_photo_flag ==='Y'">
        <img class="img-part" :src="'data:image/jpeg;base64,'+data.photo_data" alt="照片" />
      </van-cell>
      <van-cell title="申请说明" v-if="data.header.comments" v-model="data.header.comments"></van-cell>
    </ax-panel>
    <ax-panel title="申请人信息">
      <van-cell title="姓名" :value="data.header.emplid_description"></van-cell>
      <van-cell title="邮箱" v-if="data.header.email_addr">
        <a class="mail_a" :href="'mailto:'+data.header.email_addr">{{data.header.email_addr}}</a>
      </van-cell>
      <van-cell title="电话">
        <a class="link_a" :href="'tel:'+data.header.emplid_phone">{{data.header.emplid_phone}}</a>
      </van-cell>
      <van-cell title="部门" :value="data.header.deptid_description"></van-cell>
    </ax-panel>
  </section>
</template>

<script>
export default {
  props: ['data']
}
</script>

<style>
</style>
